
import FIcon from '@fixit/icons/src/components/FIcon.vue'
import CartFavoriteIcon from '../pages/cart/components/CartFavoriteIcon.vue'

export default {
  components: { FIcon, CartFavoriteIcon },
  props: {
    employees: {
      type: Array,
      required: true,
    },
    treatments: {
      type : Array,
      reguired: true
    },
    salon: {
      type: Object,
      required: false,
    },
    treatmentItem: {},
  },

  data: () => ({
    isMounted: false,
  }),

  methods: {
    getEmployeeImage(item) {
      if (item == null || ((item.imageUrlSmall == null || item.imageUrlSmall === undefined || !item.imageUrlSmall.length) && (item.imageUrlMedium == null || item.imageUrlMedium === undefined || !item.imageUrlMedium.length))) {
        return 'https://res.cloudinary.com/odin-systemer-test/image/upload/v1660295293/default_employee_qlkkiv.jpg'
      }
      if (typeof String.prototype.replaceAll == "undefined") {
              String.prototype.replaceAll = function(match, replace) {
                return this.replace(new RegExp(match, 'g'), () => replace);
              }
            }
      return item.imageUrlMedium.replaceAll('"', '') || item.imageUrlSmall.replaceAll('"', '')
    },
    isFavorite(employee) {
      let favorites = this.$store.getters['employees/getFavoriteEmployees']
      return favorites.length ? favorites.map(x => x.employeeId).includes(employee.employeeId) : false
    },
    open(employee){
      this.$router.push(`/about/${this.salon.urlFrendlyLink}/${employee.base64EmployeeId}`)
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
